/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Sent_ToastInputs */

const en_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignment notification email sent`)
};

const fr_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de notification d'affectation envoye`)
};

const de_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungs-E-Mail zur Zuweisung gesendet`)
};

const it_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email di notifica di assegnazione inviata`)
};

const ru_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письмо с уведомлением о назначении отправлено`)
};

const es_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de notificación de asignación enviado`)
};

const zh_cn2_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发送分配通知邮件`)
};

const ja_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当て通知メールを送信しました`)
};

const hi_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असाइनमेंट सूचना ईमेल भेजा गया`)
};

const pt_pt2_explorer_assignment_email_sent_toast = /** @type {(inputs: Explorer_Assignment_Email_Sent_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail de notificação de atribuição enviado`)
};

/**
* | output |
* | --- |
* | "Assignment notification email sent" |
*
* @param {Explorer_Assignment_Email_Sent_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_sent_toast = /** @type {((inputs?: Explorer_Assignment_Email_Sent_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Sent_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_assignment_email_sent_toast(inputs)
	if (locale === "de") return de_explorer_assignment_email_sent_toast(inputs)
	if (locale === "it") return it_explorer_assignment_email_sent_toast(inputs)
	if (locale === "ru") return ru_explorer_assignment_email_sent_toast(inputs)
	if (locale === "es") return es_explorer_assignment_email_sent_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_assignment_email_sent_toast(inputs)
	if (locale === "ja") return ja_explorer_assignment_email_sent_toast(inputs)
	if (locale === "hi") return hi_explorer_assignment_email_sent_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_assignment_email_sent_toast(inputs)
	return en_explorer_assignment_email_sent_toast(inputs)
});